import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
export function useInfiniteScroll(hasNextPage, isFetchingNextPage, fetchNextPage, scrollContainerRef, sentinelRef, t0) {
  const $ = _c(11);
  const rootMargin = t0 === undefined ? "100px" : t0;
  const fetchingRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isFetchingNextPage || $[3] !== rootMargin || $[4] !== scrollContainerRef || $[5] !== sentinelRef) {
    t1 = () => {
      const sentinel = sentinelRef.current;
      const scrollContainer = scrollContainerRef.current;
      if (!sentinel || !scrollContainer || !hasNextPage || isFetchingNextPage) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        const [entry] = entries;
        if (entry?.isIntersecting && hasNextPage && !isFetchingNextPage && !fetchingRef.current) {
          fetchingRef.current = true;
          fetchNextPage();
        }
      }, {
        root: scrollContainer,
        rootMargin
      });
      observer.observe(sentinel);
      return () => {
        observer.disconnect();
        fetchingRef.current = false;
      };
    };
    t2 = [hasNextPage, isFetchingNextPage, fetchNextPage, scrollContainerRef, sentinelRef, rootMargin];
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = rootMargin;
    $[4] = scrollContainerRef;
    $[5] = sentinelRef;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[8] !== isFetchingNextPage) {
    t3 = () => {
      if (!isFetchingNextPage) {
        fetchingRef.current = false;
      }
    };
    t4 = [isFetchingNextPage];
    $[8] = isFetchingNextPage;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
}